<template>
    <div class="commonFormStyles materialNewTransheet-box">
        <HeaderNav
            header-title="交付信息"
            left-icon-name="2"
            right-icon-name="3"
        ></HeaderNav>
        <section class="form-con showFontBtn">
            <van-collapse v-model="activeNames">
                <van-collapse-item name="1" class="">
                    <div slot="title">
                        <span class="iconfont icondanjubianhao"></span>
                        <span class="tit-text">基本信息</span>
                    </div>
                    <div class="form-group">
                        <van-cell-group>
                            <van-cell
                                title="工程名称"
                                :value="formData.project_name"
                                :icon="require('@/assets/images/icons/icon_2.png')"
                            ></van-cell>
                            <van-cell
                                title="施工部位"
                                :value="formData.place_name"
                                :icon="require('@/assets/images/icons/icon_gy_2.png')"
                            ></van-cell>
                            <van-cell
                                title="运输单号"
                                :value="formData.pcb_number"
                                :icon="require('@/assets/images/icons/icon_gy_1.png')"
                            ></van-cell>
                            <van-cell
                                title="到达时间"
                                :value="formData.arrive_time"
                                :icon="require('@/assets/images/icons/icon_gy_7.png')"
                            ></van-cell>
                            <van-cell
                                title="强度等级"
                                :value="formData.strength_grade_name"
                                :icon="require('@/assets/images/icons/icon_gy_3.png')"
                            ></van-cell>
                            <van-cell
                                title="外加剂"
                                :value="formData.special_require_name"
                                :icon="require('@/assets/images/icons/icon_6.png')"
                            ></van-cell>
                            <van-cell
                                title="坍落度"
                                :value="`${formData.slump}±${formData.slump_name}`"
                                :icon="require('@/assets/images/icons/icon_16.png')"
                            ></van-cell>
                        </van-cell-group>
                    </div>
                </van-collapse-item>
            </van-collapse>
            <van-form ref="transSheet" class="form-group">
                <van-cell
                    title="开始卸料时间"
                    :value="formData.unload_time"
                    :icon="require('@/assets/images/icons/icon_gy_7.png')"
                ></van-cell>
                <van-cell
                    title="结束卸料时间"
                    :value="formData.unload_over_time"
                    :icon="require('@/assets/images/icons/icon_gy_7.png')"
                ></van-cell>
                <van-cell
                    title="本车方量"
                    :value="formData.volume"
                    :icon="require('@/assets/images/icons/icon_30.png')"
                ></van-cell>
                <van-field
                    placeholder="请输入"
                    v-model="formData.sign_volume"
                    :rules="[{ required: true, message: '请输入卸料方量' }]"
                >
                    <div slot="left-icon">
                        <span class="cell8 cell-icon"></span>
                    </div>
                    <div slot="label">
                        签收方量
                    </div>
                </van-field>
            </van-form>
            <div class="upload-con group-item">
                <div class="tit">
                    <span class="iconfont icondingdan"></span>
                    <span>上传资料</span>
                </div>
                <div class="file-list">
                    <van-uploader
                        :after-read="uploadFileMethod"
                        @delete="handleFileDelete"
                        preview-image
                        preview-full-image
                        v-model="fileList"
                        multiple
                    ></van-uploader>
                </div>
            </div>
            <div class="group-item" style="border-bottom:none;">
                <div class="tit">
                    <span class="iconfont iconpingjia"></span>
                    <span>评价信息</span>
                </div>
                <div class="evaluate">
                    <div class="item" v-for="(item, index) in saveData.evaluateDetails" :key="index">
                        <label>{{ item.option_name }}</label>
                        <van-rate v-model="item.score"></van-rate>
                        <span class="tip" v-if="item.score===5">非常好</span>
                        <span class="tip" v-else-if="item.score===4">好</span>
                        <span class="tip" v-else-if="item.score===3">一般</span>
                        <span class="tip" v-else-if="item.score===2||item.score===1">差</span>
                        <span class="tip" v-else></span>
                    </div>
                </div>
            </div>
            <div class="option-con">
                <span class="iconfont iconbeizhu"></span>
                <textarea
                    placeholder="请在此输入跟进记录"
                    v-model="saveData.client_remark"
                    @focus="inputFocus($event)"
                    @focusout="inputFocusout"
                ></textarea>
            </div>
        </section>
        <footer class="commonFormBtns">
            <van-button type="info" @click="driverEvaluate">
                提交
            </van-button>
        </footer>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
import { Toast, ImagePreview } from 'vant';
import { mixin_fileUpload } from '@/assets/mixin/mixin_fileUpload';
export default {
    components: {
        HeaderNav,
    },
    mixins: [mixin_fileUpload],
    props: {},
    data() {
        return {
            activeNames: [],
            formData: {}, // 回显运输单信息
            value: 0,
            saveData: {
                pcb_number: '',
                task_number: '',
                unload_volume: 0,
                evaluateDetails: [
                    {
                        eva_id: '',
                        option_id: '1',
                        option_name: '订单响应速度',
                        score: null,
                    },
                    {
                        eva_id: '',
                        option_id: '2',
                        option_name: '物流准时程度',
                        score: null,
                    },
                    {
                        eva_id: '',
                        option_id: '3',
                        option_name: '司机服务态度',
                        score: null,
                    },
                    {
                        eva_id: '',
                        option_id: '4',
                        option_name: '业务员专业程度',
                        score: null,
                    },
                ], // 评分
                client_files: '', // 附件
                client_remark: '',
            },
            // uploadBusinessTypeCode: 'ProductionAffix',
            fileDataId: '',
            type: '',
            imgUrls: [],
        };
    },
    watch: {},
    computed: {},
    methods: {
        // 上传回调（mixin的callBackFun override，收集FileID到saveData.client_files）
        callBackFun(firmRes) {
            if (firmRes && firmRes.FileID) {
                this.saveData.client_files += firmRes.FileID + ',';
            }
        },
        // 删除文件
        handleFileDelete(file, detail) {
            const ids = this.saveData.client_files.split(',');
            ids.splice(detail.index, 1);
            this.saveData.client_files = ids.join(',') + ',';
            if (file.AFI_Code) {
                this.deleteFile(file);
            } else if (file.FileID) {
                this.$axios.delete(`${this.GLOBAL.FILE_BASE_URL}file-manage/${file.FileID}`);
            }
        },
        // 获取司机运输单
        getDriverPcb(pcb_number) {
            this.$axios
                .get('/interfaceApi/production/productpcb/get_driver_pcb?pcb_number=' + pcb_number)
                .then(res => {
                    if (res) {
                        this.formData = res;
                        this.formData.sign_volume = null;
                    }
                })
                .catch(error => {
                    this.$toast(error.Errorcode.Message);
                });
        },
        // 图片预览
        imageView(index) {
            ImagePreview({ images: this.imgUrls, startPosition: index });
        },
        // 客户评价
        driverEvaluate() {
            this.$refs.transSheet.validate().then(res => {
                this.saveData.pcb_number = this.formData.pcb_number;
                this.saveData.task_number = this.formData.task_number;
                this.saveData.sign_volume = this.formData.sign_volume;
                this.$axios
                    .post('/interfaceApi/production/productpcb/client_evaluate', this.saveData)
                    .then(res => {
                        if (res) {
                            Toast.success('操作成功');
                            this.$router.isBack = 1;
                            this.$router.go(-1);
                        }
                    })
                    .catch(error => {
                        this.$toast(error.Errorcode.Message);
                    });
            }).catch(() => {
            });

        },
        // 拉取客户评价（加载已有文件）
        getClientEvaluate() {
            this.$axios
                .get('/interfaceApi/production/productpcb/get_client_evaluate?pcb_number=' + this.pcb_number)
                .then(res => {
                    if (res) {
                        this.saveData = res;
                        if (this.saveData.client_files) {
                            this.loadExistingFiles(this.saveData.client_files);
                        }
                    }
                })
                .catch(() => {
                    // 首次评价可能没有数据，忽略错误
                });
        },
        // 加载已有文件到fileList
        loadExistingFiles(filepath) {
            const fileStr = filepath.replace(/,$/, '');
            const fileIds = fileStr.split(',').filter(Boolean);
            fileIds.forEach(fileId => {
                this.fileList.push({
                    url: `${this.GLOBAL.FILE_BASE_URL}file-manage/${fileId}/download`,
                    FileID: fileId,
                    isImage: true,
                    status: 'done',
                });
            });
        },
        // 展示电子运单
        toElectronicTicket(data) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'electronicTicket', params: { pcb_number: data.pcb_number } });
        },
        // 文本域在手机端输入完空白问题
        inputFocus() {
            clearTimeout(this.timer);
        },
        inputFocusout() {
            this.timer = setTimeout(() => {
                window.scrollTo(0, 0);
                // 间隔设为10，减少页面失去焦点定时器的突兀感，
            }, 10);
        },
    },
    created() {
        this.pcb_number = this.$route.params.pcb_number;
        this.fileDataId = this.pcb_number;
        this.getDriverPcb(this.pcb_number);
        this.getClientEvaluate();
    },
    mounted() {
    },
};
</script>
<style lang="stylus">
.materialNewTransheet-box
    height calc(100% - 44rpx)
    .hader-nav
        position initial
    .form-con
        height 100%
        overflow-y auto
        overflow-x hidden
        .icondanjubianhao
            font-size 18rpx
            margin-right 10rpx
            float left
            color #666
        .tit-text
            float left
        .view-electronic
            float right
            color #E60000
        .van-form
            .van-cell
                padding 0
        .van-collapse-item__content
            padding 0 0 0 0
        .van-cell__title
            font-size 14rpx
        .van-cell__value
            font-size 14rpx
        .van-collapse-item__title--expanded
            .van-cell__title
                color #3495FB
                .icondanjubianhao
                    color #3495FB
        .form-group
            .van-cell
                padding 10rpx 10rpx 10px 16rpx;
                font-size 16rpx
            .van-field__control
                text-align right
            .cell-icon
                width 16rpx
                height 16rpx
                display inline-block
                background-repeat no-repeat
                background-size 100% 100%
                margin-top 3rpx
            .cell1
                background-image url(./../../../assets/images/icons/icon_2.png)
            .cell2
                background-image url(./../../../assets/images/icons/icon_gy_2.png)
            .cell3
                background-image url(./../../../assets/images/icons/icon_gy_1.png)
            .cell4
                background-image url(./../../../assets/images/icons/icon_gy_7.png)
            .cell5
                background-image url(./../../../assets/images/icons/icon_gy_3.png)
            .cell6
                background-image url(./../../../assets/images/icons/icon_6.png)
            .cell7
                background-image url(./../../../assets/images/icons/icon_16.png)
            .cell8
                background-image url(./../../../assets/images/icons/icon_30.png)
            .van-field__left-icon
                margin-right 6rpx
            .van-cell:not(:last-child)::after
                left 0
            .star
                color #E60000
            .van-field__label
                width 160rpx
    .option-con
        width 100%
        padding 14rpx
        padding-top 0
        position relative
        textarea
            height 132rpx
            width 100%
            border 1px solid #D7D7D7
            border-radius 5rpx
            padding 10rpx
        .iconbeizhu
            position absolute
            left 20rpx
            top 20rpx
            display none
    .group-item
        padding 10rpx 16rpx
        border-bottom 1px solid #F0F0F0
        .tit
            color #3495FB
            margin-bottom 15rpx
            .iconfont
                font-size 16rpx
                margin-right 10rpx
        .situation-types
            span
                height 30rpx
                background #F1F1F1
                border-radius 8rpx
                line-height 30rpx
                padding 0 12rpx
                display inline-block
                font-size 14rpx
                margin 0 6rpx 10rpx 0
        .evaluate
            .item
                margin-bottom 15rpx
                font-size 14rpx
                overflow hidden
                label
                    line-height 0rpx
                    width 145rpx
                    float left
                .van-rate
                    float left
                    margin-right 20rpx
                .tip
                    float left
        &.upload-con
            .file-list
                li
                    overflow hidden
                    border-radius 4rpx
                    float left
                    margin-right 10rpx
                    width 80rpx
                    height 80rpx
                    img
                        width 80rpx
                        height 80rpx


</style>
<style>
.materialNewTransheet-box .van-collapse-item__title .van-cell__right-icon::before{
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
}
.materialNewTransheet-box .van-collapse-item__title--expanded .van-cell__right-icon::before{
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
}
.materialNewTransheet-box input::-webkit-input-placeholder{
    color: #E60000;
}
.materialNewTransheet-box .van-field__error-message{
    text-align: right;
}
</style>
